const shellClass =
  'w-full overflow-hidden rounded-lg border border-card-line border-t-card-line-top bg-card text-fg-muted shadow-soft';

const HEADER_HEIGHT = 36;
const ROW_HEIGHT = 32;

/** Column widths (in %) that roughly match the real grid, so the skeleton
 *  settles into the table instead of jumping when data arrives. */
const COLUMN_WIDTHS = [16, 12, 9, 9, 9, 10, 11, 8, 8, 8];

const SkeletonRow = ({ opacity }) => (
  <div
    className="flex items-center gap-4 border-b border-line px-3"
    style={{ height: ROW_HEIGHT, opacity }}
  >
    {COLUMN_WIDTHS.map((width, index) => (
      <div
        key={index}
        className="h-2.5 rounded-full bg-surface-raised"
        style={{ width: `${width}%` }}
      />
    ))}
  </div>
);

export const StatStatus = ({ status, error, height = 500 }) => {
  if (status === 'loading') {
    const rows = Math.max(4, Math.floor((height - HEADER_HEIGHT) / ROW_HEIGHT));

    return (
      <div className={shellClass} style={{ height }} role="status" aria-busy="true">
        <span className="sr-only">Loading statistics…</span>
        <div className="animate-pulse" aria-hidden="true">
          <div
            className="flex items-center gap-4 border-b border-line bg-surface-raised px-3"
            style={{ height: HEADER_HEIGHT }}
          >
            {COLUMN_WIDTHS.map((width, index) => (
              <div
                key={index}
                className="h-2.5 rounded-full bg-line"
                style={{ width: `${width}%` }}
              />
            ))}
          </div>
          {Array.from({ length: rows }, (_, index) => (
            // Fade the tail so the block reads as "more below" rather than as
            // a table that ends abruptly.
            <SkeletonRow key={index} opacity={Math.max(0.15, 1 - index / rows)} />
          ))}
        </div>
      </div>
    );
  }

  if (status === 'failed') {
    return (
      <div className={`${shellClass} flex items-center justify-center`} style={{ height }}>
        <div className="p-5 text-center">
          <p className="mb-2 text-lg text-danger">Error loading statistics</p>
          <p className="text-sm">{error}</p>
        </div>
      </div>
    );
  }

  return null;
};
